// import * as Config from '../../../config';
import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "../../../vendor/router-ROUTER_TARGET";
import IconInfo from '../content/list/svg/IconInfo';
import './Recommendation.css';

import PopupCTA from '../popup/PopupCTA';
import PopupContent from '../popup/PopupContent';
import PopupButton from '../popup/PopupButton';
import IconClose from '../svg/IconClose';

import { setPopup } from "../../../actions/index";

function InfosRecommendations({ path = null, force = false, isCuration = false, className }) {
  // `path` is optional: callers relying on `force` pass none. v5 returned null
  // on a null path, v6 throws — so match a constant and discard it when unused.
  const matched = useMatch({ path: path || '/', end: true });
  let match = (path) ? matched : null;
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const showModal = () => {
    const GroupButtons = ({ cancelClick = () => {} }) => {
      const onClickFeedback = () => {
        if (!user) {
          window.open(`https://research.beatport.com/jfe/form/SV_8c9gqRQPD6tSv1I?authentication=no&source=web_app&location=track_page&url=${window.location.href}`, `_blank`);
        } else {
          let base = `https://research.beatport.com/jfe/form/SV_8c9gqRQPD6tSv1I?authentication=yes&source=web_app&email=${user.email}&first_name=${user.firstname}&username=${user.name}&url=${window.location.href}`;
          if (window.location.href.includes('cart')) {
            window.open(`${base}&location=main_cart`, `_blank`);
          } else if (window.location.href.includes('recommendations')) {
            window.open(`${base}&location=my_recommendations`, `_blank`);
          } else if (window.location.href.includes('playlists')) {  
            window.open(`${base}&location=playlist`, `_blank`);
          } else if (window.location.href.includes('charts')) {
            if (isCuration) {
              window.open(`${base}&location=curation`, `_blank`);
            } else {
              window.open(`${base}&location=chart`, `_blank`);
            }
          } else {
            window.open(`${base}&location=track_page`, `_blank`);
          }
        }
      }
      const overrideClick = () => {
        cancelClick();
      }
      return (
        <div className={'popupv2-group-buttons popupv2-recommendation-buttons flexRow center'} onClick={overrideClick}>
          <IconClose className={`popup-recommendation-close`} onClick={overrideClick} size={18} color={'#B3B3B3'} />
          <PopupButton label={'No, Thanks'} className={'pb-close'} />
          <PopupButton label={'Give Feedback'} className={'pb-primary'} closeAuto={true} onClick={onClickFeedback} />
        </div>
      )
    }

    let title = 'Better Recommendations';
    let description = 'We’ve fine-tuned our engine with behavior from your playlists, cart activity, and collection – plus picks from our global DJ community and expert curators. ';
    if (window.location.href.includes('cart')) {
      title = 'Smarter Cart Recommendations';
      description += 'Your recommendations are tailored to the tracks in your cart, update as you add more, and get smarter the more you dig.';
    } else if (window.location.href.includes('recommendations')) {
      title = 'Smarter Daily Recommendations';
      description += 'Your recommendations refresh daily, and get smarter the more you dig.';
    } else if (window.location.href.includes('playlists')) { 
      title = 'Smarter Playlist Recommendations';
      description += 'Your recommendations are tailored to the tracks in your playlist, update as you add more, and get smarter the more you dig.' 
    } else if (window.location.href.includes('charts')) {
      title = (isCuration) ? 'Smarter Curation Recommendations' : 'Smarter Chart Recommendations';
      description += 'Your recommendations are tailored to the tracks you’re viewing, update as new ones are added, and get smarter the more you dig'
    } else {
      title = 'Smarter Track Recommendations';
      description += 'Your recommendations are tailored to the track you’re viewing, refresh weekly, and get smarter the more you dig.'
    }

    dispatch(setPopup({ content: (
      <PopupCTA title={title} className={'popupv2-recommendation'} blurClose={true}>
        <PopupContent className={'popupv2-recommendation-content'}>
          <span className={'popupv2-recommendation-section'}>{description}</span>
          <span className={'popupv2-recommendation-section'}>We’re just getting started, let us know what you think.</span>
        </PopupContent>
        <GroupButtons />
      </PopupCTA>
    ), className: 'popup-side', blurClose: true }));
  };
  return (match || force) ? (
    <div className={`button-info-recommendation ${className}`} onClick={showModal}>
      <IconInfo className={'icon-info-recommendation'}  />
    </div> 
  ) : null
}

export default InfosRecommendations;
